export const styles = {
	card: {
		border: 'none',
		borderRadius: '0.4rem',
	},
	cardContentReset: {
		'&:last-child': {
			paddingBottom: 0,
		},
		height: '100%',
		margin: 0,
		overflowY: 'visible',
		padding: 0,
		position: 'relative',
	},
	container: {
		maxWidth: '100%',
		minHeight: '9.8rem',
		position: 'relative',
		mt: 2,
		p: 2,
		border: '1px solid #ddd',
		borderRadius: '6px',
		background: '#fafafa',
		whiteSpace: 'pre-wrap',
	},
	contentBox: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		background: '#E7F8FF',
	},
	contentText: {
		color: '#000000DE',
		textAlign: 'left',
		whiteSpace: 'pre-wrap',
		padding: {
			lg: '24px',
			md: '24px',
			sm: '24px',
			xs: '8px 16px 8px 16px',
		},
	},
}
